import React, {useState, useEffect, getGlobal} from 'reactn';
import { useFirestore } from 'reactfire';
import {message} from 'antd';

const TreatmentShow = (props) => {
    let firestore = useFirestore();
    const [state, setState] = useState([]);
    const [loadingBtn, setLoadingBtn] = useState(false);
    useEffect(() => {
        getTreatment();
    }, []);

    const getTreatment = () => {
        let records = [];
        firestore.collection("Treatment_records").orderBy('timestamp').where("appointment_id", "==", props.appID).get()
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                records.push({data: doc.data(), id: doc.id});
            });
        }).finally(() => {
            if(records.length > 0) {
                setState(records);
            }
        });
    }

    const showTranslatedArray = (arr) => {
        let newarr = [];
        arr && arr.map((single) => {
            if(single === "رات") {
                newarr.push('Night');
            } else if (single === "صبح") {
                newarr.push('Morning');
            } else if (single === "دوپہر") {
                newarr.push('Afternoon');
            } else if (single === "شام") {
                newarr.push('Evening');
            } else if (single === "حسب ضرورت") {
                newarr.push('As Required');
            }
        });
        return newarr;
    }


    const showDosageTranslated = (dosage) => {
        if (dosage === 'ایک قطرے') {
            return "One Drop";
        } else if (dosage === 'دو قطرے') {
            return "Two Drops";
        } else if (dosage === 'تین قطرے') {
            return "Three Drops";
        } else if (dosage === 'تین قطرے') {
            return "Three Drops";
        } else if (dosage === 'چار قطرے') {
            return "Four Drops";
        } else if (dosage === 'پانچ قطرے') {
            return "Five Drops";
        } else if (dosage === 'آدھی گولی') {
            return "Half Tablet";
        } else if (dosage === 'ایک گولی') {
            return "One Tablet";
        } else if (dosage === 'دو گولیاں') {
            return "Two Tablets";
        } else if (dosage === 'تین گولیاں') {
            return "Three Tablets";
        } else if (dosage === 'چار گولیاں') {
            return "Four Tablets";
        } else if (dosage === 'پانچ گولیاں') {
            return "Five Tablets";
        } else if (dosage === 'ایک کیپسول') {
            return "One Capsule";
        } else if (dosage === 'دو کیپسول') {
            return "Two Capsule";
        } else if (dosage === 'تین کیپسول') {
            return "Three Capsule";
        } else if (dosage === 'چار کیپسول') {
            return "Four Capsule";
        } else if (dosage === 'پانچ کیپسول') {
            return "Five Capsule";
        } else if (dosage === 'آدھا چاۓ کا چمچ') {
            return "Half Tea Spoon";
        } else if (dosage === 'ایک چاۓ کا چمچ') {
            return "One Tea Spoon";
        } else if (dosage === 'دو چاۓ کے چمچ') {
            return "Two Tea Spoons";
        } else if (dosage === 'تین چاۓ کے چمچ') {
            return "Three Tea Spoons";
        } else if (dosage === 'چار چاۓ کے چمچ') {
            return "Four Tea Spoons";
        } else if (dosage === 'پانچ چاۓ کے چمچ') {
            return "Five Tea Spoons";
        } else if (dosage === 'ایک ٹیکے') {
            return "One Injection";
        } else if (dosage === 'دو ٹیکے') {
            return "Two Injections";
        } else if (dosage === 'تین ٹیکے') {
            return "Three Injections";
        } else if (dosage === 'چار ٹیکے') {
            return "Four Injections";
        } else if (dosage === 'پانچ ٹیکے') {
            return "Five Injections";
        } else if (dosage === 'ایک بار') {
            return "One Time";
        } else if (dosage === 'دو بار') {
            return "Two Times";
        } else if (dosage === 'تین بار') {
            return "Three Times";
        } else if (dosage === 'چار بار') {
            return "Four Times";
        } else if (dosage === 'پانچ بار') {
            return "Five Times";
        }
    }

    const showDurationTranslated = (duration) => {
        if (duration === "ایک دن") {
            return "One day";
        } else if (duration === "دو دن") {
            return "Two days";
        } else if (duration === "تین دن") {
            return "Three days";
        } else if (duration === "چار دن") {
            return "Four days";
        } else if (duration === "پانچ دن") {
            return "Five days";
        } else if (duration === "چھ دن") {
            return "Six days";
        } else if (duration === "دس دن") {
            return "Ten days";
        } else if (duration === "ایک ہفتہ") {
            return "One week";
        } else if (duration === "دو ہفتے") {
            return "Two weeks";
        } else if (duration === "تین ہفتے") {
            return "Three weeks";
        } else if (duration === "ایک مہینہ") {
            return "One month";
        }else if (duration === "دو ماہ") {
            return "Two months";
        }else if (duration === "جاری رکھیں") {
            return "Continue";
        }
        
    }

    const showWhenTranslated = (whentotake) => {
        if (whentotake === "کھانے سے پہلے") {
            return "Before meal";
        } else if (whentotake === "کھانے کے دوران") {
            return "During meal";
        } else if (whentotake === "کھانے کے بعد") {
            return "After meal";
        }
    }

    const bringToCurrent = (values) => {
        setLoadingBtn(true);
        values.medicine = state;
        Object.keys(values).forEach(key => values[key] === undefined && delete values[key]);

        let collectionRef = firestore.collection('Treatment_records');



        let _values = values.map((med)=> {

           return collectionRef.add({
                patient: firestore.collection("patients").doc(getGlobal().patientID),
                appointment: firestore.collection("appointments").doc(getGlobal().appointmentId),
                appointment_id: getGlobal().appointmentId,
                medicine_info: med.data.medicine_info,
                timestamp: new Date(),
              })
            
        } ) 
        console.log("this isssssssssssssssssssssss",_values);
        

        Promise.all(_values).then(() => {
            setLoadingBtn(false);
            message.success('Medicine forwarded successfully. !Please click Refresh to get them')
        }).catch(error => {
            message.error("Error adding records: ", error);
          });

    }

    return (
        <React.Fragment>
            {state.length > 0 && <div className="medicines_container"> <div className="medicineFinalReport"> 
                <h2>Treatment</h2>
                {props.showCarryForward && <button style={{float:'right'}} onClick={() => bringToCurrent(state)}>Bring to Current Treatment</button>}
                {/* <Button onClick={() => bringToCurrent()}>
                    Bring these to Current
                </Button> */}

                <ul>
                    {state && state.map((item) => {
                        return <li key={Math.random()}>
                            <div className="showMep">
                                <h4>{`${item.data.medicine_info.medicine && item.data.medicine_info.medicine.medicine_name} (${item.data.medicine_info.medicine && item.data.medicine_info.medicine.formula})  - ${item.data.medicine_info.medicine && item.data.medicine_info.medicine.weight} - ${item.data.medicine_info.medicine && item.data.medicine_info.medicine.type}`}</h4>
                                <p>{showDosageTranslated(item.data.medicine_info.dosage)} {`${item.data.medicine_info.dosage_in_ml ? `${String(item.data.medicine_info.dosage_in_ml)}ml` : ''}`} at {showTranslatedArray(item.data.medicine_info.frequency).join(",")} {item.data.medicine_info.duration && <>for</>}  {showDurationTranslated(item.data.medicine_info.duration)} {showWhenTranslated(item.data.medicine_info.when)}</p>
                            </div>
                            <div style={{width:'100%', textAlign: 'right'}}>
                                {item.data.medicine_info.dosage_in_ml && <strong>{`${String(item.data.medicine_info.dosage_in_ml)}ml`}</strong>} &nbsp;
                                {item.data.medicine_info.dosage && <strong>{item.data.medicine_info.dosage}</strong>} &nbsp;
                                {item.data.medicine_info.frequency && <strong>{item.data.medicine_info.frequency.join(",")}</strong>} &nbsp;
                                {(item.data.medicine_info.frequency && item.data.medicine_info.frequency != "حسب ضرورت") && <strong>کو &nbsp;</strong> }
                                {item.data.medicine_info.when && <strong>{item.data.medicine_info.when}</strong>} &nbsp;
                                {item.data.medicine_info.duration && <strong>{item.data.medicine_info.duration}</strong>} &nbsp;
                                {(item.data.medicine_info.duration && item.data.medicine_info.duration != "جاری رکھیں") && <strong>کے لیے</strong>}
                            </div>
                            {item.data.medicine_info.note && <p>Note: {item.data.medicine_info.note}</p>}

                        </li>
                    })}
                
            </ul></div></div> }           
        </React.Fragment>
    );
}


export default TreatmentShow;
